import React from "react";
import CheckItem from "./CheckItem";

/*
  Casillas de las que a lo mucho una va marcada, con el aspecto de las de
  GrupoCasillasItem: "PROGRAMACIÓN: [X] recolección [ ] entrega".

  Es un solo campo del form: value es el `valor` de la opción marcada (o null).
  Marcar una opción desmarca la otra y volver a picar la marcada la deja en null, cosa
  que un Radio no permite.

  Va como hijo directo de <FormItem name="..." noStyle>.
*/
export const OPCIONES_RECOLECCION_ENTREGA = [
  { valor: "recoleccion", texto: "Recolección" },
  { valor: "entrega", texto: "Entrega" },
];

const CasillasExclusivasItem = ({ value, onChange, opciones = [], disabled }) => (
  <>
    {opciones.map((opcion) => (
      <CheckItem
        key={opcion.valor}
        checked={value === opcion.valor}
        disabled={disabled}
        onChange={(marcada) => onChange && onChange(marcada ? opcion.valor : null)}
      >
        {opcion.texto}
      </CheckItem>
    ))}
  </>
);

export default CasillasExclusivasItem;
